// Module
var code = "<div class=\"tooltip-arrow\"></div> <div class=\"tooltip-inner\" uib-tooltip-template-transclude=\"contentExp()\" tooltip-template-transclude-scope=\"originScope()\"></div> ";
// Exports
export default code;